import React from 'react';
import PropTypes from 'prop-types';
import TUBE from '@learningblocks/exp-constants/lib/Images/mc_tube.svg';
import ROTOR from '@learningblocks/exp-constants/lib/Images/mc_rotor.svg';
import TUBE_ROTOR from '@learningblocks/exp-constants/lib/Images/mc_tube_rotor.svg';
import {Image} from '@learningblocks/storybook-components';

export function Slot(props) {
  const className = `${props.className} ${props.className}_pos--${props.position}`;
  const renderContent = () => {
    if (props.solution && props.rotor) return <Image src={TUBE_ROTOR} />;
    else if (props.solution) return <Image src={TUBE} />;
    else if (props.rotor) return <Image src={ROTOR} />;
    else return null;
  };
  return <div className={className}>{renderContent()}</div>;
}

Slot.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
  /**
   * specifies if solution is present in slot
   */
  solution: PropTypes.bool,
  /**
   * specifies if rotor is present in slot
   */
  rotor: PropTypes.bool,
  /**
   * position id of slot
   */
  position: PropTypes.number,
};

Slot.defaultProp = {
  className: '',
};
